/*
 * @Author       : huanghua
 * @Date         : 2025-12-22 10:19:49
 * @LastEditors  : huanghua
 * @LastEditTime : 2025-12-22 10:20:56
 * @Description  :
 * @FilePath     : /BM-Main/src/router/engineer-transfer.js
 */
export default {
  path: '/engineer-transfer', // 工程师企微链接中转页面
  name: 'engineer-transfer',
  meta: {
    title: '专属工程师',
    level: 3
  },
  component: () => import(/* webpackChunkName: "engineer-transfer" */ 'app/engineer-transfer/index.vue')
}
